import { types, getParent } from 'mobx-state-tree'

export const OtherCost = types.model({
  description: '',
  cost: 0.00,
}).actions(self => ({
  setDescription(newDescription) {
    self.description = newDescription
  },
  setCost(cost) {
    self.cost = cost
  },
  remove() {
    getParent(self, 2).removeItem(self)
  }
}))


// WEBPACK FOOTER //
// ./src/models/OtherCost.js